<template>
  <v-card class="group-list-layout">
    <v-card-title class="group-list-title-layout">
      <span class="group-list-title">조직도</span>
      <div class="collapse-button blue white--text" @click="toggleExpand">
        <span>{{ isAnyCollapsed ? '+' : '-' }}</span>
      </div>
    </v-card-title>
    <div class="d-flex justify-space-between px-6 mb-3">
      <v-btn class="button" outlined @click="showAdd">부서추가</v-btn>
      <v-btn class="button save" outlined @click="uploadUser">부서원등록</v-btn>
      <v-btn class="button red white--text" outlined @click="showDelete">삭제목록</v-btn>
    </div>
    <v-divider></v-divider>
    <group-tree
        ref="groupTree"
        class="pa-5 group-list"
        :org-list="orgList"
        :is-show-delete="isShowDelete"
        @select="selectData"
    />
    <member-upload
        :is-show="isShowUpload"
        @refresh="$emit('refresh')"
        @close="isShowUpload = false"
    />
    <organization-add
        :is-show="isShowAdd"
        @refresh="$emit('refresh')"
        @close="isShowAdd = false"
    />
  </v-card>
</template>

<script>
import GroupTree from "@/pages/Member/components/MemberManage/GroupTree.vue";
import OrganizationAdd from "@/pages/Member/popup/OrganizationAdd.vue";
import MemberUpload from "@/pages/Member/popup/MemberUpload.vue";

export default {
  name: "OrganizationChart",
  props: ["orgList"],
  components: {MemberUpload, OrganizationAdd, GroupTree},
  data() {
    return {
      selectedData: {},
      isShowAdd: false,
      isShowUpload: false,
      isShowDelete: false,
      isAnyCollapsed: true
    }
  },
  methods: {
    selectData(value) {
      this.selectedData = value;
      this.isShowDelete = false;
      this.$emit("select", value);
    },
    showAdd() {
      this.isShowAdd = true;
    },
    uploadUser() {
      this.isShowUpload = true;
    },
    showDelete() {
      this.isShowDelete = true;
      this.$emit("delete");
    },
    toggleExpand() {
      const tree = this.$refs.groupTree;
      if (tree?.hasAnyCollapsed()) {
        tree.expandAll();
        this.isAnyCollapsed = false;
      } else {
        tree.collapseAll();
        this.isAnyCollapsed = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group-list-layout {
  margin: 10px;
  width: 20vw;
  min-width: 400px;
  .group-list-title-layout {
    display: flex;
    justify-content: space-between;
    .group-list-title {
      font-weight: bold;
    }
    .collapse-button {
      width: 40px;
      display: flex;
      justify-content: center;
      border-radius: 10px;
      span {
        text-align: center;
      }
    }
    .collapse-button:hover {
      cursor: pointer;
    }
  }
  .group-list {
    max-height: 65vh;
    overflow-y: auto;
  }
}
</style>